import { useContext, useEffect } from "react";
import "./AccountInformation.scss";
import ExistingCustomer from "./ExistingCustomer/ExistingCustomer";
import NewCustomer from "./NewCustomer/NewCustomer";
import Progress from "../Progress/Progress";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../context/GlobalContext";
import HelpSection from '../../Common/HelpSection/HelpSection';
import CardButtonLeftArrow from "../../../assets/CardButtonLeftArrow.svg";
import ExistingCustomerNote from "../ExistingCustomerNote/ExistingCustomerNote";
import NewCustomerNote from "../NewCustomerNote/NewCustomerNote";

function AccountInformation({ rtl }: any) {
  const [state, dispatch]: any = useContext(GlobalContext);
  const { t } = useTranslation();
  const win: any = window;

  const handleBack = () => {
    window.location = win["home_page_url"];
  }

  useEffect(() => {
    dispatch({ type: 'RESET_DATA' })
  }, [])

  const dir = rtl ? 'right' : 'left';
  return (
    <>
      <div className={`container account-information-container ai-${dir}`}>
        <div className="row acc">
          <div className="col-sm-12 d-flex">
            <div className={`back-icon-container ${dir}`} onClick={handleBack}>
              <img className={`back-icon`} src={CardButtonLeftArrow} alt="arrow" />
            </div>
            <Progress rtl={rtl} title={t('Account_Information')} />
          </div>
          <div className='account-Information row mx-0'>
            <div className="col-12 col-lg-7">
              <Typography className={`account-form-title fontFamily-${dir}`} rtl={rtl}>{t('Account_Information')}</Typography>
              <div className={`account-information-form-container fontFamily-${dir}`}>
                {state.userType === "newcustomer" ? (
                  <NewCustomer rtl={rtl} dir={dir} page={t("Product_Information")} />
                ) : (
                  <ExistingCustomer rtl={rtl} dir={dir} page={t("Product_Information")} />
                )}
              </div>
            </div>
            <div className="col-12 col-lg-5">
                {state.userType === "newcustomer" ? (
                  <NewCustomerNote rtl={rtl}/>
                ) : (
                  <ExistingCustomerNote rtl={rtl}/>
                )}
              <HelpSection rtl={rtl} className="mx-auto" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AccountInformation;
